import type { ChatMessage as ChatMessageType } from "../types";

/**
 * メッセージ配列から最後のタイムスタンプを取得し、1ms加算した新しいDateオブジェクトを返す
 * メッセージが空の場合は現在時刻を返す
 *
 * @param messages 現在のメッセージ配列
 * @returns 新しいメッセージ用のタイムスタンプ
 */
export const getNextMessageTimestamp = (messages: ChatMessageType[]): Date => {
  if (messages.length === 0) {
    return new Date();
  }

  // メッセージ配列から最後のメッセージのタイムスタンプを取得
  const lastMessage = messages[messages.length - 1];
  const lastTimestamp = lastMessage?.timestamp;

  if (!lastTimestamp) {
    return new Date();
  }

  // 最後のタイムスタンプに1ms加算
  const nextTimestamp = new Date(lastTimestamp.getTime() + 1);
  return nextTimestamp;
};
